import * as React from 'react';

function SvgPrivateNote(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.927 13.658H7.438a.626.626 0 01-.619-.625.62.62 0 01.62-.616h4.488a.62.62 0 01.619.616c0 .342-.281.625-.62.625zM7.438 8.25h2.789c.338 0 .619.283.619.625a.62.62 0 01-.619.617H7.438a.62.62 0 01-.619-.617c0-.342.28-.625.62-.625zm9.274-.733c-.192 0-.403.002-.597.004-.164.002-.317.004-.434.004l-.566-.003c-.272-.003-.583-.005-.936-.005-1.51-.009-2.756-1.259-2.756-2.784V2.05a.38.38 0 00-.38-.383H6.639c-2.055 0-3.721 1.691-3.721 3.758v8.983c0 2.167 1.749 3.925 3.894 3.925h4.2a5 5 0 016.073-5.216V7.893a.372.372 0 00-.372-.375zM14.29 6.299c.575.006 1.374.008 2.053.006.347 0 .524-.42.283-.673L14.976 3.9l-1.672-1.757c-.247-.259-.678-.08-.678.279v2.196c0 .922.751 1.681 1.664 1.681z"
        fill="currentColor"
      />
      <path
        d="M15 18.337a.408.408 0 100-.815.408.408 0 000 .816z"
        fill="currentColor"
      />
      <path
        d="M16.57 16.383v-.313c0-.675-.163-1.57-1.57-1.57-1.408 0-1.57.895-1.57 1.57v.313c-.7.087-.93.442-.93 1.315v.465c0 1.024.313 1.337 1.338 1.337h2.325c1.024 0 1.337-.313 1.337-1.337v-.465c0-.873-.23-1.228-.93-1.316zM15 18.684a.756.756 0 010-1.51.754.754 0 110 1.51zm-1.162-2.325h-.058v-.29c0-.732.208-1.22 1.22-1.22s1.22.488 1.22 1.22v.293h-2.382v-.003z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgPrivateNote;
